import AppSearchAPIConnector from '@elastic/search-ui-app-search-connector';

interface SearchConnectorConfig {
  elasticEngineName?: string;
}

export const searchConnector = (config?: SearchConnectorConfig) => {
  return new AppSearchAPIConnector({
    searchKey:
      process.env.NEXT_PUBLIC_ELASTIC_SEARCH_KEY ||
      'Missing elastic search key',
    engineName:
      config?.elasticEngineName ||
      process.env.NEXT_PUBLIC_ELASTIC_ENGINE ||
      'Missing elastic engine name',
    endpointBase:
      process.env.NEXT_PUBLIC_ELASTIC_ENDPOINT || 'Missing elastic endpoint',
  });
};
